import {DomSanitizer} from '@angular/platform-browser';
import {Constants} from './../../../services/constants';
import {Router, ActivatedRoute} from '@angular/router';
import {EndpointsService} from './../../../services/endpoints.service';
import {HttpApiService} from './../../../services/http-api.service';
import {SharedService} from './../../../services/shared.service';
import {Component, OnInit} from '@angular/core';
import {UserService} from "../../../services/user.service";
import {UUID} from "angular2-uuid";

declare var sha256: any;

@Component({
  selector: 'app-onebill-payment',
  templateUrl: './onebill-payment.component.html',
  styleUrls: ['./onebill-payment.component.scss']
})
export class OnebillPaymentComponent implements OnInit {

  iframeUrl: any;
  profile: any = {};
  pricingPlans: any;
  frameHeight: number = 600;
  quantity: number = 1;
  selectedPricingPlanInternal: any = {};
  tierId: number;

  planId: any;
  user: any;
  secretKey: string;
  selectedPricingPlan: any = {};
  selectedTier: any = {};

  constructor(private userService: UserService,
              private sharedService: SharedService,
              private api: HttpApiService,
              private endpoints: EndpointsService,
              private route: ActivatedRoute,
              private router: Router,
              private sanitizer: DomSanitizer) {
  }

  ngOnInit() {
    this.userService.getCurrentUser()
      .then(user => {
        this.user = user;
        this.loadIframe();
      });

    this.loadData();
  }

  loadData() {
    this.route.queryParams
      .subscribe(data => {
        let profileId = this.sharedService.decodeBase64(data['profileId']);
        this.planId = data['planId'];
        this.tierId = data['tierId'];
        this.profile = this.sharedService.getData("selectedProfile");
        this.quantity = data["quantity"] ? data["quantity"] : 1;
        this.quantity = parseInt(this.quantity.toString());

        if (!this.profile || this.profile.id != profileId) {
          this.profile = {};
          //load current profile from server
          this.api.get(this.endpoints.getProfileUrl() + "/" + profileId + "?domain=" + Constants.TENANT_ID())
            .subscribe(profile => {
              this.profile = profile;
              this.setSelectedPlan();
            });
        } else {
          this.setSelectedPlan();
        }

      });
  }

  setSelectedPlan() {
    this.pricingPlans = this.profile.details.pricingPlans;
    this.pricingPlans.forEach(item => {
      if (item.planId === this.planId) {
        this.selectedPricingPlan = item;
        if (this.selectedPricingPlan.pricingTiers && this.selectedPricingPlan.pricingTiers.length > 0) {
          this.selectedTier = this.selectedPricingPlan.pricingTiers.filter(item => item.id == this.tierId)[0];
        }
      }
    });
  }

  loadIframe() {
    if (this.secretKey) {
      this.loadIframeHelper();
    } else {
      this.api.get(this.endpoints.getCheckoutSecretKeyUrl() + "?tenantDomain=" + Constants.TENANT_ID(), true)
        .subscribe(response => {
          this.secretKey = response.secretKey;
          this.loadIframeHelper();
        })
    }
  }

  loadIframeHelper() {
    this.sharedService.setParameter("oneBillResponse", {});
    let find = '-';
    let re = new RegExp(find, 'g');
    let token = UUID.UUID().replace(re, "").slice(4);
    let accNum = this.user.accountNumber;
    let page = "payment_profile";
    let queryParams = "tenant=saasmax&accNum=" + accNum + "&page=" + page + "&token=" + token + "&timestamp=" + Date.now();

    let secretUrl = queryParams + this.secretKey;
    let hash = sha256(secretUrl);
    let checkOutLink = "https://app.onebillsoftware.com/hostedcomponentslogin.do?" + queryParams + "&signature=" + hash;
    this.iframeUrl = this.sanitizer.bypassSecurityTrustResourceUrl(checkOutLink);
  }

  frameChanged(myIframe) {
    try {
      if (myIframe.contentWindow.location && myIframe.contentWindow.location.href) {
        let params = this.sharedService.getParameter("oneBillResponse", true);
        if (params.responseStatus == "cancel") {
          this.router.navigateByUrl("/");
        }
        else if (params.responseStatus == "failure") {
          this.loadIframe();
        }
        else if (params.responseStatus == "success") {
          this.frameHeight = 150;
          this.placeOrder();
        }
      }
    } catch (e) {
      console.debug("iframe changed: exception");
    }
  }

  placeOrder() {

    let order: any = {pricingPlanId: this.selectedTier.tierId, quantity: this.quantity};
    this.api.post(this.endpoints.getPlaceOrderUrl(), order, true)
      .subscribe((response: any) => {

          this.frameHeight = 0;
        },
        error => {
          console.error(error);
        });
    return false;
  }

  back() {
    this.router.navigateByUrl("/onebill-checkout?profileId=" + this.sharedService.encodeBase64(this.profile.id) + "&planId=" + this.planId + "&quantity=" + this.quantity);
  }

}



// WEBPACK FOOTER //
// ./src/app/components/buyer/onebill-payment/onebill-payment.component.ts